import {
  DrawerHeader as DrawerHeaderPrimitive,
  ModalHeaderProps
} from '@chakra-ui/react';
import { ReactNode, createContext, useContext, useMemo } from 'react';

type DrawerHeaderProps = ModalHeaderProps & {
  hasImage?: boolean;
};

export function DrawerHeader({
  hasImage,
  children,
  ...props
}: DrawerHeaderProps): ReactNode {
  const drawerHeaderContext = useMemo<DrawerHeaderContext>(
    () => ({ hasImage }),
    [hasImage]
  );

  return (
    <DrawerHeaderPrimitive {...props} py="4" px="4" position="relative">
      <DrawerHeaderContext.Provider value={drawerHeaderContext}>
        {children}
      </DrawerHeaderContext.Provider>
    </DrawerHeaderPrimitive>
  );
}

type DrawerHeaderContext = { hasImage?: boolean };

const DrawerHeaderContext = createContext<DrawerHeaderContext | null>(null);

export function useDrawerHeaderContext(): DrawerHeaderContext {
  const context = useContext(DrawerHeaderContext);

  if (context === null) {
    throw new Error(
      "useDrawerHeaderContext can't be used outside of DrawerHeader"
    );
  }

  return context;
}
